import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/common/Header/Header';
import GenericMessage from 'src/Components/GenericMessage/GenericMessage';
import DocumentBox from './DocumentBox';
import APIEndpoints from '../../../Admin/api/APIEndpoints';
import { axiosInstance } from '../../../../src/api/axios';
import DocumentBoxSkeleton from './DocumentBoxSkeleton';
import CustomClientError from '../../errorhandling/CustomClientError';
import './manage-help-documents.scss';

const ManageHelpDocuments = () => {
  const [userGuideDocuments, setUserGuideDocuments] = useState([]);
  const [glossaryDocuments, setGlossaryDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(true);
  const [isDocAPIFailed, setIsDocAPIFailed] = useState(false);
  const [isDocNotFound, setIsDocNotFound] = useState(false);
  const { t } = useTranslation();

  const getAllHelpDoc = async () => {
    try {
      setDocumentsLoading(true);
      console.log('getAllHelpDoc called >>>>>>>>>>');
      const helpDocumentsResponse = await axiosInstance.get(
        APIEndpoints.getAllHelpCenterDocuments(),
      );
      const documentLists =
        helpDocumentsResponse?.data?.Response?.HelpPageList || [];
      console.log('Manage  documents are >>>>>>>>>> ', documentLists);
      const addedPermissionAtribute = documentLists.map((doc) => ({
        ...doc,
        view: true, //Later will be using this while implementing based on permissions
        edit: true, //Later will be using this while implementing based on permissions
        awaitInitialUpload: !doc?.value,
      }));
      console.log('addedPermissionAtribute >>>>>>> ', addedPermissionAtribute);
      const userGuideDocs = addedPermissionAtribute.filter((item) =>
        item.key.includes('UserGuide'),
      );
      const glossaryDocs = addedPermissionAtribute.filter((item) =>
        item.key.includes('Glossary'),
      );

      console.log('userGuideDocs >>>>>>> ', userGuideDocs);
      console.log('glossaryDocs >>>>>>> ', glossaryDocs);
      setUserGuideDocuments(userGuideDocs);
      setGlossaryDocuments(glossaryDocs);
      setIsDocAPIFailed(false);
      setIsDocNotFound(false);
    } catch (err) {
      if (err.toString().includes('404')) {
        setIsDocNotFound(true);
      }
      setIsDocAPIFailed(true);
      console.log('error in gatAllDoc >>>>>>>>>>', err);
    } finally {
      setDocumentsLoading(false);
    }
  };

  useEffect(() => {
    console.log('UseEffect called >>>>>>>>>>>>>>>');
    getAllHelpDoc();
  }, []);

  return (
    <Container fluid className="pr-0">
      <Header
        linkTo={'/admin/admin-dashboard'}
        header={t('admin.pages.manage_help_documents.module')}
      />
      {isDocAPIFailed ? (
        <div>
          {isDocNotFound ? (
            <CustomClientError ErrorHeading="No Help Center Documents found!" />
          ) : (
            <CustomClientError
              ErrorHeading="Something went wrong with request!"
              ErrorMessage="Please try again."
            />
          )}
        </div>
      ) : (
        <>
          <div className="manage-help-documents-container">
            <div className="row-label">User Guides</div>
            <div className="documents-container">
              {documentsLoading ? (
                <Row>
                  {[1, 2, 3].map((item) => (
                    <DocumentBoxSkeleton key={item} />
                  ))}
                </Row>
              ) : userGuideDocuments?.length === 0 && !documentsLoading ? (
                <CustomClientError ErrorHeading="No User Documents found!" />
              ) : (
                <Row>
                  {userGuideDocuments.map((userGuideDoc) => (
                    <DocumentBox
                      key={userGuideDoc?.oid}
                      documentKey={userGuideDoc?.key}
                      documentOid={userGuideDoc?.value}
                      documentName={userGuideDoc?.document_name || ''}
                      oid={userGuideDoc?.oid}
                      documentFor={userGuideDoc?.document_for || ''}
                      documentTitle={userGuideDoc?.document_title || ''}
                      updatedDate={userGuideDoc?.updated_date || ''}
                      updatedBy={userGuideDoc?.updated_by || ''}
                      documentDescription={userGuideDoc?.keydesc || ''}
                      viewPermission={userGuideDoc?.view || false}
                      editPermission={userGuideDoc?.edit || false}
                      awaitInitialUpload={
                        userGuideDoc?.awaitInitialUpload || false
                      }
                      getAllHelpDoc={getAllHelpDoc}
                    />
                  ))}
                </Row>
              )}
            </div>
          </div>
          <div className="manage-help-documents-container">
            <div className="row-label">Glossaries</div>
            {documentsLoading ? (
              <div className="documents-container">
                <Row>
                  {[1, 2, 3].map((item) => (
                    <DocumentBoxSkeleton key={item} />
                  ))}
                </Row>
              </div>
            ) : glossaryDocuments?.length === 0 && !documentsLoading ? (
              <CustomClientError ErrorHeading="No Glossary Documents found!" />
            ) : (
              <>
                <div>
                  <GenericMessage
                    wrapperClasses="mt-4 mb-4"
                    message="Audience Scope: Glossary marked as 'Multi-User Glossary' are accessible to Super Admins, Insurers, Employers, Providers, and Brokers."
                    messageType={'info'}
                    showMessage={true}
                    hideCloseButton={true}
                  />
                </div>
                <div className="documents-container">
                  <Row>
                    {glossaryDocuments.map((glossaryDoc) => (
                      <DocumentBox
                        key={glossaryDoc?.oid}
                        documentKey={glossaryDoc?.key}
                        documentOid={glossaryDoc?.value}
                        documentName={glossaryDoc?.document_name || ''}
                        oid={glossaryDoc?.oid}
                        documentFor={glossaryDoc?.document_for || ''}
                        documentTitle={glossaryDoc?.document_title || ''}
                        updatedDate={glossaryDoc?.updated_date || ''}
                        updatedBy={glossaryDoc?.updated_by || ''}
                        documentDescription={glossaryDoc?.keydesc || ''}
                        viewPermission={glossaryDoc?.view || false}
                        editPermission={glossaryDoc?.edit || false}
                        awaitInitialUpload={
                          glossaryDoc?.awaitInitialUpload || false
                        }
                        getAllHelpDoc={getAllHelpDoc}
                      />
                    ))}
                  </Row>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </Container>
  );
};

export default ManageHelpDocuments;
